/* eslint-disable */
import React, { useEffect, useState } from 'react'

// components
import { Autocomplete, TextField, CircularProgress } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import InputLabel from '../../../inputLabel'

// helpers
import { getAdminApplications, isSuperAdmin } from '../../../../helpers/user'

// hooks
import useLocalApplications from '../../../../hooks/useLocalApplications'
import { useTranslation } from 'react-i18next'

const ApplicationField = ({ group, setGroup, key, errors, inputPlaceholder }) => {
  const isSuperAdminUser = isSuperAdmin()
  const [searchText, setSearchText] = useState('')
  const [open, setOpen] = useState(false)
  const { areApplicationsLoading, applications, getApplications } =
    useLocalApplications()
  const adminApplications = getAdminApplications()
  const options = isSuperAdminUser ? applications : adminApplications
  const { t } = useTranslation()

  useEffect(() => {
    if (!isSuperAdminUser && options?.length == 1) {
      const application = options[0]
      setGroup({
        ...group,
        application,
        groupName: application ? `${application} - ` : '',
      })
    }
  }, [])

  const handleInputChange = (event, newInputValue) => {
    setSearchText(newInputValue)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && isSuperAdminUser) {
      getApplications(searchText)
    }
  }

  const handleApplicationChange = (event, value) => {
    if (event.key !== 'Enter') {
      setGroup({
        ...group,
        application: value,
        groupName: value ? `${value} - ` : '',
      })
    }
  }

  useEffect(() => {
    if (isSuperAdminUser) {
      setOpen(true)
    }
  }, [applications])

  return (
    <div style={{ width: '385px', marginTop: '17px' }}>
      <InputLabel label={t('create-group-label-search')} styles={{marginBottom: '8px'}}/>
      <Autocomplete
        disablePortal
        id="application"
        key={key}
        freeSolo={!!isSuperAdminUser}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        hiddenLabel="true"
        loading={areApplicationsLoading}
        options={options}
        inputValue={searchText}
        onChange={handleApplicationChange}
        onInputChange={handleInputChange}
        onKeyDown={handleKeyDown}
        value={group?.application}
        renderInput={(params) => (
          <TextField
            {...params}
            error={errors?.application}
            helperText={errors?.application}
            placeholder='Type in application name'
            InputProps={{
              ...params.InputProps,
              classes: {
                input: `${inputPlaceholder || ''}`,
              },
              startAdornment: (
                <SearchIcon sx={{ color: 'action.active', marginRight: 1 }} />
              ),
              endAdornment: (
                <>
                  {areApplicationsLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  )
}
export default ApplicationField
